import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MedicalRecordRelease } from '@web/csl-lib-models';
import { Observable } from 'rxjs';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';

@Injectable()
export class MrrUpdateService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  getMedicalRecordRelease(clinicId: number, healthRecordId: string, mrrId: number): Observable<MedicalRecordRelease> {
    return this.http.get<MedicalRecordRelease>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/mrr/${mrrId}?includeEvents=true`);
  }

  updateStatus(clinicId: number, healthRecordId: string, medicalRecordReleaseId: number, newState: number, comment: string): Observable<MedicalRecordRelease> {
    return this.http.patch<MedicalRecordRelease>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/mrr/${medicalRecordReleaseId}?includeEvents=true`, {
      'state': newState,
      'comment': comment
    });
  }

}
